import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { FormattedMessage } from 'react-intl'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import KanBoIcon from 'components/KanBoIcon'
import {
  ListItem
} from 'components/List'
import EditLabel from '../EditLabel'
import { withBoardPermission } from 'dataProviders/Board'
import { ModalBoardContext } from 'components/Modal'
import { useColor } from 'utils/colors'

const draggingStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#ccc',
  opacity: 0.8,
  zIndex: 2
}

export class Label extends React.Component {
  static propTypes = {
    boardContext: PropTypes.object.isRequired,

    leftSidebar: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.number.isRequired,

    labelColor: PropTypes.string.isRequired,

    requestRemoveLabel: PropTypes.func.isRequired,

    sortable: PropTypes.object.isRequired
  }

  handleClick = () => {
    const { boardContext, leftSidebar, id, name, color } = this.props

    leftSidebar.push(() => <ModalBoardContext boardId={boardContext.id}><EditLabel id={id} name={name} color={color} /></ModalBoardContext>)
  }

  handleRemoveClick = () => {
    const { id, requestRemoveLabel } = this.props

    requestRemoveLabel({
      id
    })
  }

  render () {
    const {
      permission,
      name,

      labelColor,

      sortable
    } = this.props

    const menu =
      permission.owner ? [{
        icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
        title: <FormattedMessage id='REMOVE' />,
        onClick: this.handleRemoveClick
      }] : undefined

    return (
      <ListItem
        ref={ref => {
          const node = findDOMNode(ref)
          sortable.connectDragSource(permission.member ? node : undefined)
        }}
        draggable={permission.member}
        icon={
          <KanBoIcon
            name='kanbo-16-label'
            style={{
              color: labelColor,
              fontSize: 16
            }}
          />
        }
        menu={menu}
        onClick={permission.owner ? this.handleClick : undefined}
      >
        {sortable.isDragging && <div style={draggingStyle} />}
        {name}
      </ListItem>
    )
  }
}

const LabelWithColor = React.forwardRef((props, ref) => {
  const labelColor = useColor(props.color)

  return (
    <Label
      ref={ref}
      labelColor={labelColor}
      {...props}
    />
  )
})

export default withLeftSidebar(withBoardPermission(LabelWithColor))
